// 1. Ready translated locale messages
// The structure of the locale message is the hierarchical object structure with each locale as the top property
import { createI18n } from 'vue-i18n';
import { IWorkflowManager } from 'workflow-compiler-provider';

interface Ii18nConfig {
  workflowManager?: IWorkflowManager,
}

export const i18nConfig: Ii18nConfig = {};

const messages = {
  en: {
    errors: {
      genericErrorTitle: 'An error occurred',
      genericErrorDescription: 'If the problem persists, please reach us out',
      physicalNetworkError: 'Please, try again later, a network error occurred',
    },
    errorPage: {
      title: 'Something wrong',
      message: 'You link might be expired or invalid. Please contact support.',
      button: 'Contact support',
    },
    validations: {},
  },
  he: {
    validations: {},
  },
};

export const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  missingWarn: false,
  // missingWarn: true,
  escapeParameter: true,
  globalInjection: true,
  globalInstall: true,
  resolvedMessage: true,
  messages,
});
